import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { Content } from "ionic-angular";
import { ConversationData, TypeBadgeData, TypeConversationData } from "../../..";
import { CheckUtils } from "../../../ui-utils/check-utils";
var HTML_TEMPLATE = "\n<div class=\"od-messages\">\n\t <ion-content padding (ionScroll)=\"onScroll($event)\">\n\t\t  <ion-infinite-scroll (ionInfinite)=\"$event.waitFor(doInfinite($event))\" [position]=\"'top'\" [threshold]=\"'10px'\">\n\t\t    <ion-infinite-scroll-content></ion-infinite-scroll-content>\n\t\t  </ion-infinite-scroll>\n\t\t  \n\t\t  <ion-list *ngIf=\"data !=null && data.messages !=null\">\n\t\t        <od-message *ngFor=\"let message of data.messages;let i=index; let last = last;\" [data]=\"message\" \n\t\t        \t[rightSide]=\"getSide(message.author)\" [mySide]=\"getMySide(message.author)\">    \n\t\t        \t {{onRestoreScroll(data,i)}}\n\t\t\t\t</od-message>\n\t\t  </ion-list>\n\t  </ion-content>\n\t  <od-typing-indicator  *ngIf=\"composingUsers !=null\" [datas]=\"composingUsers\" class=\"od-messages-composing-users\"></od-typing-indicator>\n  \t  <div class=\"od-messages-zone\">\n\t\t<div *ngIf=\"_messageCounter != 0\" (click)=\"gotoLastReadMessage()\" class=\"od-messages-bubble\">\n\t\t   {{ 'Messages.newMessages' | translate: {counter: _messageCounter } }}</div>\n\t   </div>\n</div>\n";
var CSS_STYLE = "\n.od-messages {\n\tdisplay:block;\n\theight:100%;\n\twidth:100%;\n}\n.od-messages-zone{\n\tposition: absolute;\n    bottom: 11px;\n\tdisplay: flex;\n    width: 100%;\n    justify-content: center;\n    z-index:1001;\n    opacity:0.7;\n}\n\n.od-messages-zone:hover{\n    opacity:1;\n}\n\n.od-messages-bubble{\n    border: 1px solid #25aed8;\n    width: fit-content;\n    padding: 6px 12px;\n    border-radius: 16px;\n    box-shadow: 2px 2px 6px #a4a4a4;\n    background-color: #25aed8;\n    color: white;\n    cursor: pointer;\n}\n\n.od-messages-composing-users{\n\tposition: absolute;\n    bottom: 0;\n    z-index: 1000;\n    width: 100%;\n    left: 0;\n    padding-left: 24px;\n    background-image: linear-gradient(to bottom, rgba(246,249,251,0), rgba(246,249,251,1)); \n  }\n";
var Messages = /** @class */ (function () {
    function Messages() {
        this.scroll = new EventEmitter();
        this.messageLoad = new EventEmitter();
        this.SCROLL_TOLERANCE = 50;
        this.init = false;
        this._messageCounter = 0;
    }
    Object.defineProperty(Messages.prototype, "scrollTop", {
        set: function (value) {
            this._scrollTop = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Messages.prototype, "counter", {
        get: function () {
            return this._messageCounter;
        },
        set: function (value) {
            this._messageCounter = value;
        },
        enumerable: true,
        configurable: true
    });
    Messages.prototype.getSide = function (author) {
        if (!CheckUtils.isEmpty(author)) {
            switch (this.data.type) {
                case TypeConversationData.PUBLIC:
                    if (author.type === TypeBadgeData.BOT)
                        return true;
                    switch (author.type) {
                        case TypeBadgeData.USER:
                            return true;
                    }
                    break;
                case TypeConversationData.PRIVATE:
                    return this.fromId === author.id;
            }
        }
        return false;
    };
    Messages.prototype.getMySide = function (author) {
        if (this.fromType == null) {
            return author.type == TypeBadgeData.ANONYMOUS;
        }
        else if (!CheckUtils.isEmpty(author)) {
            switch (this.data.type) {
                case TypeConversationData.PUBLIC:
                    switch (author.type) {
                        case TypeBadgeData.USER:
                        case TypeBadgeData.TEAM:
                        case TypeBadgeData.BOT:
                            return this.fromType.indexOf("USER") > -1;
                        case TypeBadgeData.CUSTOMER:
                        case TypeBadgeData.ANONYMOUS:
                            return this.fromType.indexOf("CUSTOMER") > -1 || this.fromType.indexOf("ANONYMOUS") > -1;
                    }
                    break;
                case TypeConversationData.PRIVATE:
                    return this.fromId === author.id;
            }
        }
        return false;
    };
    Messages.prototype.onRestoreScroll = function (data, index) {
        var _this = this;
        if (this._index < index && !CheckUtils.isEmpty(this._scrollTop) && this._scrollTop != -2) {
            if (this._scrollTop == -1)
                setTimeout(function () {
                    _this.content.scrollToBottom(0);
                    setTimeout(function () {
                        _this.init = true;
                    }, 1000);
                }, 100);
            else
                this.content.scrollTo(0, this._scrollTop);
            this.scrollTop = -2;
        }
        this._index = index;
    };
    Messages.prototype.onScroll = function () {
        var _this = this;
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(function () {
            if (!CheckUtils.isEmpty(_this.content))
                _this.scroll.emit({ x: _this.content.scrollLeft, y: _this.content.scrollTop });
        }, 800);
    };
    Messages.prototype.scrollOnBottom = function () {
        var contentDimensions = this.content.getContentDimensions();
        return contentDimensions.scrollTop + this.SCROLL_TOLERANCE >= contentDimensions.scrollHeight - contentDimensions.contentHeight;
    };
    Messages.prototype.gotoLastReadMessage = function () {
        this._messageCounter = 0;
        this.content.scrollToBottom(0);
    };
    Messages.prototype.doInfinite = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.messageLoad.emit(resolve);
        });
    };
    Messages.decorators = [
        { type: Component, args: [{
                    selector: "od-messages",
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    Messages.ctorParameters = function () { return []; };
    Messages.propDecorators = {
        "content": [{ type: ViewChild, args: [Content,] },],
        "composingUsers": [{ type: Input },],
        "data": [{ type: Input },],
        "fromId": [{ type: Input },],
        "fromType": [{ type: Input },],
        "scroll": [{ type: Output },],
        "messageLoad": [{ type: Output },],
        "scrollTop": [{ type: Input },],
        "counter": [{ type: Input },],
    };
    return Messages;
}());
export { Messages };
//# sourceMappingURL=messages.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui/chat/message/messages.js
// module id = 437
// module chunks = 14